import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { TrainingZoneLabel } from '../TrainingZoneLegend';
import { trainingZoneCustomName } from '../../utils/trainingZones';
import { formatWorkoutNumber } from '../../utils/workoutNumberFormat';
import './workout-intensity-inputs.css';
interface Zone { label: string; number: number; minimum: number; maximum: number }
export function selectedWorkoutZone(zones: Zone[], min: number, max: number) {
  return zones.findIndex(zone => Math.abs(zone.minimum - min) < 0.000001 && Math.abs(zone.maximum - max) < 0.000001);
}
export function WorkoutZoneList({ zones, minValue, maxValue, onChange }: { zones: Zone[]; minValue: number; maxValue: number; onChange: (values: { minValue: number; maxValue: number }) => void }) {
  const { t, i18n } = useTranslation();
  const id = useId();
  const fmt = (value: number) => formatWorkoutNumber(value, i18n.resolvedLanguage || i18n.language, { maximumFractionDigits: 0, useGrouping: false });
  const selected = selectedWorkoutZone(zones, minValue, maxValue);
  const percentSign = i18n.dir() === 'rtl' ? '٪' : '%';
  return <fieldset className="wb-zone-list">
    <legend>{t('workoutBuilder.intensityInputs.chooseRange')}</legend>
    {!zones.length && <p>{t('workoutBuilder.editor.noBoundedZones')}</p>}
    <div className="wb-zone-list__options">
      {zones.map((zone, index) => <label key={`${zone.number}-${index}`} className={`wb-zone-list__option${index === selected ? ' is-selected' : ''}`}>
        <input type="radio" name={id} checked={index === selected} onChange={() => onChange({ minValue: zone.minimum, maxValue: zone.maximum })} />
        <span className="wb-zone-option" dir={i18n.dir()}>
          <span className="wb-zone-option__name" title={zone.label}><TrainingZoneLabel number={zone.number} name={trainingZoneCustomName(zone.label)} standardName={false} ordinalLabel={t('workoutBuilder.zoneRangeNumber', { number: fmt(zone.number) })} /></span>
          <bdi className="wb-zone-option__range" dir="ltr">{fmt(zone.minimum)}–{fmt(zone.maximum)}{percentSign}</bdi>
        </span>
      </label>)}
    </div>
  </fieldset>;
}
